export default __webpack_public_path__ + "static/media/connie-amartey.44395004.jpeg";